<template>
    <label class="input" :class="{ hasError: v.$error }">
        <input
            class="input__text"
            :placeholder="placeholder"
            :type="type"
            @focus="setType"
            :min="minDate"
            v-model="date"/>
        <span class="input__error" v-if="v.$error">{{ errorText }}</span>
    </label>
</template>

<script>
export default {
    name: "inputDate",
    data() {
        return {
            type: 'text',
            // Возможность выбора минимальной даты. +2 дня от текущей даты.
            minDate: new Date(Date.now() + ( 3600 * 1000 * 48)).toISOString().substr(0, 10),
        }
    },
    props: {
        value: {
            type: String,
            default: "",
        },
        v: {
            type: Object,
            required: true,
        },
        placeholder: {
            type: String,
            default: ""
        },
        errorText: {
            type: String,
            default: "Заполните обязательное поле"
        },
    },
    computed: {
        date: {
            get() {
                return this.value;
            },
            set(value) {
                this.v.$touch();
                this.$emit("input", value);
            }
        }
    },
    methods: {
        setType() {
            this.type = 'date'
        }
    }
};
</script>
